hrd.RecycleBin = hrd.AbstractCommonInterface.extend({
	init: function(relativeTo, options) {
		var defaults = {
			impl: 'hrd.RecycleBin',
			title: 'recycle-bin',
			scope: 'none',
			position: {
				my: "center bottom",
				at: "center top+20",
				of: relativeTo
			}
		};
		this._super($.extend(true, {}, defaults, options));
		this.recycleBinId = this._toId('recycle-bin');
		this.recycleBinSelector = this._toIdSelector('recycle-bin');
	},
	use: function(customOptions) {
		customOptions = customOptions || {};
		let $droppable;
		let title = customOptions.title || this.settings.title;
		let scope = customOptions.scope || this.settings.scope;
		let position = $.extend({}, this.settings.position, customOptions.position);
		let usingChromaFlow = $('body').usingChromaFlow();
		let $bin = $(this.recycleBinSelector);
		if ($bin.exists()) {
			$bin.find('.dashlet-header').html(title);
			$droppable = $bin.find('.recycle-bin-content');
			$droppable.setDroppableScope(scope);
		} else {
			let iconSize = usingChromaFlow ? 'fa-2x' : 'fa-5x';
			var b = `
				<div class="recycle-bin dashlet-panel ui-corner-all ui-helper-hidden">
					<div class="dashlet-header ui-widget-header ui-corner-top">${title}</div>
					<div class="recycle-bin-content ui-widget-content dashlet-content ui-corner-bottom" style="position:relative;">
						<i class="f-icon fas fa-trash-alt ${iconSize}"></i>
					</div>
				</div>
			`;
			$bin = $(b);
			$bin.attr('id', this.recycleBinId).appendTo('body');

			if(usingChromaFlow) {
				$bin.addClass('ui-helper-hidden-important');
			}

			$droppable = $bin.find('.recycle-bin-content');
			$droppable.droppable({
				scope: scope,
				activeClass: 'ui-state-focus',
				hoverClass: 'ui-state-highlight',
				tolerance: 'touch',
				activate: (event, ui) => {
					if(usingChromaFlow) {
						$bin.removeClass('ui-helper-hidden-important');
					}

					$(ui.helper).css('z-index', '200'); // so that is 'higher' that recycle bin itself
				},
				drop: (event, ui) => {
					$(ui.helper).data('droppable-deferred').resolve({ recycle: true });
				},
				deactivate: (event, ui) => {
					if(usingChromaFlow) {
						$bin.addClass('ui-helper-hidden-important');
					}

					this.close();
				}
			});
		}
		if(usingChromaFlow) {
			$bin
				.css({
					top: 'unset',
					bottom: 'unset',
					left: 'unset',
					right: 'unset'
				})
				.show()
				.position(position);
		} else {
			$bin.show().position(position);
		}
	},
	close: function() {
		$(this.recycleBinSelector).hide();
	}
});